import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { servicesData } from '../data/servicesData';
import { FaChevronDown } from 'react-icons/fa';

const MegaMenu = ({ scrolled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Group services into categories for better organization
  const serviceCategories = {
    'Digital Marketing': servicesData.slice(0, 8),
    'Design & Development': servicesData.slice(8, 12),
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => setIsOpen(true)}
        className="text-gray-900 hover:bg-gradient-to-r hover:from-orange-300 hover:via-pink-300 hover:to-purple-300 hover:bg-clip-text hover:text-transparent transition-all uppercase text-base font-medium tracking-wider flex items-center gap-1"
      >
        SERVICES
        <FaChevronDown 
          className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} 
          size={12} 
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <div
              className="fixed inset-0 bg-black/20 z-40"
              onClick={() => setIsOpen(false)}
            />
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              onMouseLeave={() => setIsOpen(false)}
              className="absolute top-full left-0 mt-2 w-[800px] bg-white rounded-xl shadow-2xl z-50 p-8 border border-gray-200"
            >
              <div className="grid grid-cols-2 gap-8">
                {Object.entries(serviceCategories).map(([category, services]) => (
                  <div key={category}>
                    <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4 pb-2 border-b border-gray-200">
                      {category}
                    </h3>
                    <ul className="space-y-2">
                      {services.map((service) => (
                        <li key={service.id}>
                          <Link
                            to={`/services/${service.slug}`}
                            onClick={() => setIsOpen(false)}
                            className="block px-3 py-2 text-gray-700 hover:text-orange-500 hover:bg-orange-50 rounded-lg transition-colors text-sm"
                          >
                            {service.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <div className="mt-6 pt-6 border-t border-gray-200">
                <Link
                  to="/services"
                  onClick={() => setIsOpen(false)}
                  className="inline-block text-orange-500 font-semibold hover:text-orange-600 transition-colors text-sm"
                >
                  View All Services →
                </Link>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MegaMenu;

